module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABaSURBVAiZdcw7EYAwFETR+8AADh4SKGlWFA5ACUQGHZMIgUQJDQXDZ8t7ZtYk7UDL947KzMIPYmahzjlv7t4A/QOnGONYA5RSVndvge7yJaU0vC4lzZLmezsBIqcVTBewvk8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/daosanjiao.png
// module id = mS+3
// module chunks = 4